var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootballicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_22",
    "data-name": "Component 11 \\u2013 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 56,
    height: 56,
    rx: 5,
    transform: "translate(180 362)",
    fill: "#5fb42e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-180 -362)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_12331",
    "data-name": 12331,
    transform: "translate(180 362.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M67.5,39.144a24.322,24.322,0,0,0-4.041-10.7A2.462,2.462,0,0,0,61.925,27.4a44.2,44.2,0,0,0-4.49.273c0,3.538-.006,6.854.011,10.17a1.578,1.578,0,0,0,.241.792C59.82,42,61.968,45.352,64.33,49.047l3.455-3.376V40.528C67.69,40.067,67.58,39.608,67.5,39.144Z",
    transform: "translate(-11.785 -15.67)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M68.678,40.911c-3.674.744-7.391,1.277-11.09,1.9a2.915,2.915,0,0,0-1.222.285c-2.1,1.588-4.159,3.232-6.268,4.887l1.31,2.3h2.571c.454-.106.9-.241,1.362-.313A27.822,27.822,0,0,0,70.62,42.4C69.969,41.8,70.151,40.612,68.678,40.911Z",
    transform: "translate(-23.122 5.146)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M54.831,29.083q4.571,1.94,9.163,3.83a3.492,3.492,0,0,0,1.441.47c1.59-.14,3.168-.413,5.013-.673A23.727,23.727,0,0,0,68.8,30.579,26.978,26.978,0,0,0,58.2,23.84q-1.531-.529-3.065-1.052H53.995L51.567,24.6c.717,1.2,1.468,2.512,2.291,3.781A2.2,2.2,0,0,0,54.831,29.083Z",
    transform: "translate(-20.852 -22.789)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M57.9,46.535a31.9,31.9,0,0,1-7.857-3.185c-2.149-1.394-4.313-1.274-6.923-1.654.617.553.94.87,1.29,1.152a27.15,27.15,0,0,0,10.9,5.338c1.332.314,2.685.543,4.028.811h.572A2.437,2.437,0,0,0,57.9,46.535Z",
    transform: "translate(-33.906 6.432)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M39.956,32.007,39.5,33.685v4.571l.464,1.721C41.4,37.23,40.3,34.633,39.956,32.007Z",
    transform: "translate(-39.5 -8.542)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M66.96,37.643c-1.868-2.639-3.712-5.3-5.5-7.993a1.879,1.879,0,0,0-1.986-.982c-3.786.376-7.581.668-11.366,1.059a1.921,1.921,0,0,0-1.356.784q-2.116,4.27-4.032,8.637a2.072,2.072,0,0,0,.042,1.606c1.884,3.458,3.849,6.872,5.78,10.3a3.206,3.206,0,0,0,3.734,1.837,17.028,17.028,0,0,1,3.132-.035v-.293c1.474,0,2.95-.051,4.42.019a1.589,1.589,0,0,0,1.705-1.135q2.735-5.958,5.573-11.868A1.669,1.669,0,0,0,66.96,37.643Z",
    transform: "translate(-34.735 -13.728)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M67.257,32.641a1.8,1.8,0,0,0-1.5-.536q-4.014.647-7.989,1.519a2.193,2.193,0,0,0-1.338,1.025Q53.439,40.8,50.612,47.037a1.889,1.889,0,0,0,.19,1.6c1.392,1.869,2.868,3.678,4.373,5.458a6.16,6.16,0,0,0,1.428.94c3.748-.688,7.346-1.346,10.943-2.013a3.157,3.157,0,0,0,2.4-1.806c1.08-2.219,2.17-4.433,3.294-6.631a2.435,2.435,0,0,0-.12-2.662C71.15,38.84,69.261,35.7,67.257,32.641Z",
    transform: "translate(-22.483 -8.412)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M44.616,35.495a1.414,1.414,0,0,0,1.663.869c4.162-.412,8.334-.728,12.5-1.124a2.317,2.317,0,0,0,1.325-.606c1.575-1.581,3.1-3.211,4.612-4.855a1.469,1.469,0,0,0,.448-1.039,6.525,6.525,0,0,0-6.506-5.368c-4.873.233-9.128,1.09-12.072,5.031-.368.493-.842.9-1.254,1.366C42.965,32.417,42.993,32.4,44.616,35.495Z",
    transform: "translate(-33.371 -21.888)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M52.783,47.016a2.142,2.142,0,0,0-.263-1.178q-3.314-5.551-6.695-11.063c-.2-.329-.539-.745-.865-.8-1.248-.2-2.518-.27-3.864-.4-.535,2.974-1.718,5.751-.846,8.679a25.369,25.369,0,0,0,5.057,9.169,2.449,2.449,0,0,0,1.23.86c1.9.361,3.825.606,5.721.891C52.451,50.98,52.644,49,52.783,47.016Z",
    transform: "translate(-38.822 -6.11)",
    fill: "#5fb42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M49.727,24.41a22.217,22.217,0,0,0-8.418,8.251C45.184,30.975,46.949,27.185,49.727,24.41Z",
    transform: "translate(-36.705 -20.283)",
    fill: "#5fb42e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/football.icon.079637d34fbb85fa01f5b1411b9d4e4b.svg";
export { ForwardRef as ReactComponent };